import { Layout, Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { createElement, useEffect, useMemo, useState } from 'react';
import MenuList from '../../constants/MenuList';
import { IconLogo, IconLogoSmall } from '../../assets/Images/icons/logo';
import classNames from 'classnames';
import ModalConfirm from '../Shared/modal/confirm';
import { IconNewTab } from '../../assets/Images/icons/icon-landing';
import GlobalService from '../../services/Global.service';
import PropTypes from 'prop-types';
import { filterNull } from '../../util/util';
import { usePermissionContext } from '../../context/permission-context';

const { Sider } = Layout;

const Sidebar = ({ collapsed, broken, setCollapsed, setBroken, children }) => {
    const { t } = useTranslation();
    const [pathname, setPathname] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    const [openDs, setOpenDs] = useState(false);
    const [loadingURL, setLoadingURL] = useState(false);

    const [subMenuItems, setSubMenuItems] = useState([]);

    const permissionContext = usePermissionContext();

    const permission = useMemo(
        () => permissionContext?.permission,
        [permissionContext?.permission]
    );

    useEffect(() => {
        if (permission) {
            const genKeyName = permission.map((item) => {
                const subMenuList = item.subMenuList.map((subItem) => {
                    return {
                        ...subItem,
                        keyName: item.mainMenuName + ' ' + subItem.subMenuName,
                    };
                });
                return {
                    ...item,
                    keyName: item.mainMenuName,
                    subMenuList,
                };
            });

            const filterChildren = (subItem, menuPermissionItem) => {
                return menuPermissionItem.subMenuList.some(
                    (x) => x.keyName === subItem.keyPermission && x.permission
                );
            };

            const mapMenuList = (item) => {
                const menuPermissionItem = genKeyName.find(
                    (x) => x.keyName === item.keyPermission
                );

                if (
                    menuPermissionItem?.permission &&
                    menuPermissionItem.packagePermission
                ) {
                    const children = item.children?.filter((subItem) =>
                        filterChildren(subItem, menuPermissionItem)
                    );
                    return {
                        ...item,
                        children,
                    };
                }
                return null;
            };

            const newSubMenu = filterNull(
                MenuList({ t, setOpenDs }).map(mapMenuList)
            );

            setSubMenuItems(newSubMenu);
        }
    }, [permission, t]);

    useEffect(() => {
        let pathArray = location.pathname.split('/');
        setPathname(`/${pathArray[1]}/${pathArray[2]}`);
        if (pathArray[1] === 'policy') {
            setPathname('/policy');
        }
        if (pathArray[1] === 'dpia') {
            setPathname('/dpia');
        }
        if (pathArray[1] === 'data-inquiry') {
            setPathname('/data-inquiry');
        }

        setOpenKeys([`/${pathArray[1]}`]);
    }, [location.pathname]);

    const onCollapse = () => {
        setCollapsed(!collapsed);
    };
    const left = collapsed ? (broken ? 0 : 80) : 250;

    const onClick = (e) => {
        navigate(e.key);
    };

    const [openKeys, setOpenKeys] = useState([pathname]);

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    };

    const switchPathDataHub = async () => {
        setLoadingURL(true);
        try {
            const { data } = await GlobalService.getDatahubURL();
            const url = data?.resultData?.datahubUrl;
            setOpenDs(false);
            setLoadingURL(false);
            window.open(url);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Layout>
            <Sider
                className={classNames('sidebar_', { collapsed })}
                width={250}
                collapsible
                collapsed={collapsed}
                onCollapse={onCollapse}
                onBreakpoint={(broken) => {
                    setBroken(broken);
                    if (broken) {
                        setCollapsed(true);
                    }
                }}
                trigger={null}
            >
                <div className="flex items-center justify-center py-6">
                    <Link to="/">
                        {!collapsed ? <IconLogo /> : <IconLogoSmall />}
                    </Link>
                </div>
                <Menu
                    onClick={onClick}
                    openKeys={openKeys}
                    selectedKeys={[pathname]}
                    onOpenChange={onOpenChange}
                    mode="inline"
                    style={{ border: 'none' }}
                    items={subMenuItems}
                />
                <div className="text-white text-2xl absolute bottom-2 left-7">
                    {createElement(
                        collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                        {
                            className: 'trigger',
                            onClick: onCollapse,
                        }
                    )}
                </div>
            </Sider>
            <div
                className="w-full site duration-300"
                style={{ paddingLeft: left }}
            >
                {children}
            </div>
            <ModalConfirm
                loading={loadingURL}
                title={t('landing.modalCon')}
                text={t('landing.modalDsDes')}
                icon={<IconNewTab />}
                open={openDs}
                handelOk={() => {
                    switchPathDataHub();
                }}
                handelClose={() => setOpenDs(false)}
            />
        </Layout>
    );
};

// Validate props
Sidebar.propTypes = {
    collapsed: PropTypes.bool,
    broken: PropTypes.bool,
    setCollapsed: PropTypes.func,
    setBroken: PropTypes.func,
    children: PropTypes.node,
};

export default Sidebar;
